import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=4090d911&scoped=true"
var script = {}
import style0 from "./Company.vue?vue&type=style&index=0&id=4090d911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4090d911",
  null
  
)

export default component.exports